module.exports = __webpack_public_path__ + "assets/img/logo1.410f12b4.png";